module.exports = __webpack_public_path__ + "static/media/Preloader_2.a8c98ef9.gif";